import React from 'react'
import './CancelOrderButton.css'
import { useState, useEffect } from 'react';
import icoStorno from '../img/storno.png'
import CustomConfirm from '../components/CustomConfirm'

const CancelOrderButton = ( {tokenOfTrip , onHandleStornoOrder }) => {
    const [showConfirm, setShowConfirm] = useState(false)
    const savedTime = localStorage.getItem(tokenOfTrip);



    const [endTime,setEndTime] = useState(localStorage.getItem(tokenOfTrip + "End"))
    const [currentTime, setCurrentTime] = useState(() => {
        // Zkoušíme načíst čas z localStorage
        
        return savedTime ? new Date(savedTime) : new Date(2023, 0, 1, 2, 0, 0);
      });

 
    
      useEffect(() => {
        const intervalId = setInterval(() => {
          setCurrentTime(prevTime => {
            const newTime = new Date(prevTime - 1 * 60 * 1000);

            // Uložíme aktuální čas do localStorage
            localStorage.setItem(tokenOfTrip, newTime);
    
            // Zastavíme odpočet při dosažení 0:00
            if (newTime.getHours() === 0 && newTime.getMinutes() === 0) {
              clearInterval(intervalId);
              setEndTime(true)
              localStorage.setItem(tokenOfTrip, "done");
              
            }
    
            return newTime;
          });
        }, 1000); // Interval 1 minuta (1000 milisekund)
    
        // Uklidíme interval při odstranění komponenty
        return () => clearInterval(intervalId);
      }, []);



if(showConfirm){
  return(
    < CustomConfirm message={"Chystáte se zrušit objednávku! Přejete si zrušit objednávku?"} onConfirm={onHandleStornoOrder} onCancel={() => setShowConfirm(false)}/>
  )
  
} 

if(!endTime){
    return (
        <div className='cancelContainer' onClick={() => setShowConfirm(true)} >
            <div className="leftCancel">
                <img src={icoStorno} alt="" className='icoStorno'/>
            </div>
      
            <div className="rightCancel">
                <p>Objednávku lze zrušit do 2 min od objednání.</p>
                <h3>{currentTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</h3>
            </div>
        </div>
      )    
} else if(endTime) {
    return ""
}
 
}

export default CancelOrderButton
